(function () {
  const drawerSelector = '#MenuDrawer';
  const rootCaptions = new Map([
    ['trending now', 'Fresh drops, viral edits and best sellers'],
    ['brands', 'Shop by your favorite K-beauty brand'],
    ['products', 'Skincare, makeup, haircare and more'],
    ['shop by concern', 'Acne, dark spots, SPF, barrier and glow'],
    ['routines', 'Ready-made routines by skin goal'],
    ['kits', 'Bundles and discounted sets'],
    ['k-beauty guide', 'Ingredients, routines and how to start'],
    ['best choices', 'Curated picks from the K-Kare team'],
  ]);
  const mobileHiddenLabels = new Set([
    "this week's k-beauty edit",
    'k-kare benefits',
    'brand spotlight',
    'build your daily routine with the best of k-beauty.',
  ]);

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function escapeHtml(value) {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function setSplitMarkup(element, title, caption, modifier) {
    if (!title) return;
    const safeTitle = escapeHtml(title);
    const safeCaption = caption ? escapeHtml(caption) : '';
    element.classList.add('kkare-mobile-menu-item', modifier);
    element.innerHTML = [
      '<span class="kkare-mobile-menu-item__copy">',
      `<span class="kkare-mobile-menu-item__title">${safeTitle}</span>`,
      safeCaption ? `<span class="kkare-mobile-menu-item__caption">${safeCaption}</span>` : '',
      '</span>',
    ].join('');
  }

  function setLeadingTextMarkup(element, title, caption, modifier) {
    if (!title) return;
    const safeTitle = escapeHtml(title);
    const safeCaption = caption ? escapeHtml(caption) : '';
    const wrapper = document.createElement('span');
    wrapper.className = 'kkare-mobile-menu-item__copy';
    wrapper.innerHTML = [
      `<span class="kkare-mobile-menu-item__title">${safeTitle}</span>`,
      safeCaption ? `<span class="kkare-mobile-menu-item__caption">${safeCaption}</span>` : '',
    ].join('');

    element.classList.add('kkare-mobile-menu-item', modifier);
    const textNode = [...element.childNodes].find((node) => node.nodeType === Node.TEXT_NODE && cleanText(node.textContent));
    if (textNode) {
      textNode.replaceWith(wrapper);
      return;
    }
    element.prepend(wrapper);
  }

  function decorateRootItem(element, caption) {
    element.classList.add('kkare-mobile-menu-item', 'kkare-mobile-menu-item--root');
    if (!caption || element.querySelector(':scope > .kkare-mobile-menu-item__caption')) return;
    const title = element.querySelector(':scope > .heading') || element.firstElementChild;
    if (!title) return;
    const captionNode = document.createElement('span');
    captionNode.className = 'kkare-mobile-menu-item__caption';
    captionNode.textContent = caption;
    title.insertAdjacentElement('afterend', captionNode);
  }

  function isFirstPanelItem(drawer, element) {
    const rootList = drawer.querySelector('ul.drawer__menu, .drawer__menu');
    if (!rootList) return false;
    return element.closest('ul') === rootList;
  }

  function enhanceDrawer() {
    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return;

    drawer.querySelectorAll('summary.drawer__menu-item, a.drawer__menu-item').forEach((element) => {
      if (element.classList.contains('kkare-mobile-menu-item')) return;
      const raw = cleanText(element.textContent);
      if (!raw) return;

      if (mobileHiddenLabels.has(raw.toLowerCase())) {
        const owner = element.closest('li') || element;
        owner.classList.add('kkare-mobile-menu-hidden');
        return;
      }

      if (raw.includes('|')) {
        const parts = raw.split('|').map(cleanText).filter(Boolean);
        if (element.tagName === 'SUMMARY') {
          setLeadingTextMarkup(element, parts[0], parts.slice(1).join(' | '), 'kkare-mobile-menu-item--split');
        } else {
          setSplitMarkup(element, parts[0], parts.slice(1).join(' | '), 'kkare-mobile-menu-item--split');
        }
        return;
      }

      if (isFirstPanelItem(drawer, element)) {
        const caption = rootCaptions.get(raw.toLowerCase());
        decorateRootItem(element, caption || '');
        return;
      }

      if (element.matches('summary.heading.drawer__menu-item')) {
        element.classList.add('kkare-mobile-menu-item', 'kkare-mobile-menu-item--group');
      }
    });

    drawer.dataset.kkareMobileEnhanced = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceDrawer);
  } else {
    enhanceDrawer();
  }

  document.addEventListener('shopify:section:load', enhanceDrawer);
  document.addEventListener('click', (event) => {
    if (event.target.closest('button[aria-controls="MenuDrawer"], #MenuDrawer')) {
      window.setTimeout(enhanceDrawer, 30);
      window.setTimeout(enhanceDrawer, 350);
    }
  });
})();
